import React from 'react';
import { Button, ButtonProps, Spinner } from '@cimpress/react-components';

interface SpinnerButtonProps {
    text: string;
    onClick(e: any): void;
    disabled?: boolean;
    spinning?: boolean;
    spinningText?: string;
    buttonType?: ButtonProps['variant'];
    className?: string;
    testid?: string;
}

const SpinnerButton: React.FC<SpinnerButtonProps> = (props) => {
    const { text, spinning, disabled, spinningText, buttonType, className, testid } = props;

    const onClick = (e: any) => {
        if (!disabled) {
            props.onClick(e);
        }
    };

    const classNames = `spinner-button${className ? ` ${className}` : ''}${disabled ? ' disabled' : ''}`;
    return (
        <Button data-testid={testid} variant={buttonType} className={classNames} onClick={onClick}>
            {!spinning && <div className='button-text'>{text}</div>}
            {spinning && <Spinner className='centerSpinner' size='medium' />}
            {spinning && !!spinningText && <div className='button-text'>{spinningText}</div>}
        </Button>
    );
};

export default React.memo(SpinnerButton);
